import { render, staticRenderFns } from "./PivotGrid.vue?vue&type=template&id=53cf3e46&"
import script from "./PivotGrid.vue?vue&type=script&lang=js&"
export * from "./PivotGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\MasterBranches\\Maintenance_06.04\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53cf3e46')) {
      api.createRecord('53cf3e46', component.options)
    } else {
      api.reload('53cf3e46', component.options)
    }
    module.hot.accept("./PivotGrid.vue?vue&type=template&id=53cf3e46&", function () {
      api.rerender('53cf3e46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Gerenciais/PivotGrid.vue"
export default component.exports